import { useTranslation } from "react-i18next";

import { Text } from "@fragments";

import { buildMonthMatrix, getWeekdayLabels } from "../../../hooks/dateUtils";

import "./styles.scss";

export default function MonthGrid({
    year,
    month,
    isInRange,
    isStart,
    isEnd,
    isDisabled,
    onDayClick,
    onDayHover,
}) {
    const { t } = useTranslation("fragments");
    const matrix = buildMonthMatrix(year, month);
    const weekdayLabels = getWeekdayLabels(t);

    return (
        <div className="dpi-grid">
            <div className="dpi-grid__weekdays">
                {weekdayLabels.map((w, i) => (
                    <span key={`${w}-${i}`} className="dpi-grid__weekday">
                        <Text.span contrast={5}>{w}</Text.span>
                    </span>
                ))}
            </div>

            <div className="dpi-grid__body">
                {matrix.map((week, r) => (
                    <div key={`r-${r}`} className="dpi-grid__row">
                        {week.map((day) => {
                            const isOutside = day.getMonth() !== month;
                            const inRange = isInRange(day);
                            const start = isStart(day);
                            const end = isEnd(day);
                            const disabled = isDisabled(day);

                            const classes = [
                                "dpi-grid__cell",
                                isOutside && "is-outside",
                                inRange && "is-in-range",
                                start && "is-start",
                                end && "is-end",
                                disabled && "is-disabled",
                            ].filter(Boolean).join(" ");

                            return (
                                <button
                                    type="button"
                                    key={day.toISOString()}
                                    className={classes}
                                    onClick={() => !disabled && !isOutside && onDayClick(day)}
                                    onMouseEnter={() => !disabled && !isOutside && onDayHover(day)}
                                    disabled={disabled || isOutside}
                                    tabIndex={isOutside ? -1 : 0}
                                >
                                    <span className="dpi-grid__cell-bg" aria-hidden="true" />
                                    <span className="dpi-grid__cell-pill" aria-hidden="true" />
                                    <span className="dpi-grid__cell-label">
                                        {day.getDate()}
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
}
